import React, { useContext } from 'react';

import { CPLBanner } from '../../../../components/Banner';
import { LanguageContext } from '../../../../i18n/LanguageContext';
import headerImage from '../../images/modules/audit.jpg';

import {MapBuilderComponent} from './MapBuilder';
import styles from './Plot.module.css';

export default function PlotModule() {
    const { PLOT_ADMIN_MODULE_NAME } = useContext(LanguageContext);
    const classNames = ['row', styles['container']];
    return <div className="col-md-12">
        <div className="row banner-wrapper">
            <div className="col-md-12">
                <CPLBanner
                    img={headerImage}
                    content={PLOT_ADMIN_MODULE_NAME} />
            </div>
        </div>
        <div className={classNames.join(' ')}>
            <div className="col-lg-12 col-md-7">
                <MapBuilderComponent />
            </div>
        </div>
    </div>
}